import { Injectable } from "@angular/core";
import { NativeDateAdapter } from "@angular/material/core";

@Injectable()
export class OrdinalDateAdapter extends NativeDateAdapter {
    format(date: Date, displayFormat: Object): string {
        if (displayFormat === 'input') {
            var day = date.getDate().toString();//date.getDate();            
            const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            const month = months[date.getMonth()];
            const year = date.getFullYear();

            // if ((day == "01") || (day == "1") || (day == "21") || (day == "31")) {
            //     day += "st";
            // }
            // else if ((day == "02") || (day == "2") || (day == "22")) {
            //     day += "nd";
            // }
            // else if ((day == "03") || (day == "3") || (day == "23")) {
            //     day += "rd";
            // }
            // else {
            //     day += "th";
            // }

            return `${day} ${month} ${year}`;
        } else {
            return date.toDateString();
        }
    }
}

export const ORD_DATE_FORMATS = 
    {
        parse: {
            dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
        },
        display: {
            dateInput: 'input',
            monthYearLabel: { year: 'numeric', month: 'numeric' },
            dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
            monthYearA11yLabel: { year: 'numeric', month: 'long' },
        }
    }

export class OrdinalDateParse {
    // Return dates formatted as DD(st|nd|rd|th) MMM YYYY. (Eg: 17th JAN 2018)
    // Also takes in parameter short_date which selects the type of processing to use.
    // Example short date format: 17/01/2018 
    // Example long date format: Jan 17 2017 12:00AM
    formatDateOrdinal(inspect_date, short_date) {
        var date_parts, day, month, year;
        var months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

        if (short_date) {
            date_parts = inspect_date.split('/');
            day = date_parts[0];
            month = months[(+date_parts[1]) - 1];
            year = date_parts[2];
        } else {
            date_parts = inspect_date.split(/\s+/);
            day = date_parts[1];
            month = date_parts[0];
            year = date_parts[2];
        }

        // if ((day == "01") || (day == "1") || (day == "21") || (day == "31")) {
        //    // day += "st";
        // }
        // else if ((day == "02") || (day == "2") || (day == "22")) {
        //    // day += "nd";
        // }
        // else if ((day == "03") || (day == "3") || (day == "23")) {
        //    //day += "rd";
        // }
        // else {
        //     //day += "th";
        // }

        function removeLeadingZero(dayVal) {
            if (dayVal[0] == "0") {
                return dayVal.substring(1, dayVal.length);
            }

            else {
                return dayVal;
            }
        }

        return (removeLeadingZero(day) + " " + month + " " + year);
    }
}